import React from "react";
import { Box, Grid } from "@material-ui/core";
import Section from "@atoms/Section/Section";
import { useTranslation } from "gatsby-plugin-react-i18next";
import HeaderSubCard from "./HeaderSubCard";
import HeaderNavSubMenuList from "./HeaderNavSubMenuList";
import type { SubMenu } from "./HeaderNav";
import SocialMediaLinks from "../SocialMediaLinks/SocialMediaLinks";
import HeaderNavSubMenuChapter from "./HeaderNavSubMenuChapter";
import HeaderNavFooterCtaGroup from "./HeaderNavFooterCtaGroup";

interface Props {
	headerSubMenuShown: boolean;
	firstSubMenu: SubMenu[];
	secondSubMenu: SubMenu[];
}

const HeaderNavSubMenu: React.FC<Props> = ({
	headerSubMenuShown,
	firstSubMenu,
	secondSubMenu,
}) => {
	const { t } = useTranslation();

	return (
		<div
			className={`HeaderSubMenu--content ${
				headerSubMenuShown ? "is-shown" : ""
			}`}
		>
			<Section>
				<Box sx={{ pt: 3, pb: 3 }}>
					<Grid container>
						<Grid item xs={12} sm={12} md={6} lg={6}>
							<HeaderNavSubMenuChapter />

							<Section spacingTop="s" spacingBottom="s">
								<HeaderSubCard />
							</Section>

							{/* <HeaderNavFooterCtaGroup /> */}
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							{firstSubMenu.map((item) => (
								<HeaderNavSubMenuList data={item} />
							))}
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							{secondSubMenu.map((item: any) => (
								<HeaderNavSubMenuList data={item} />
							))}
							<SocialMediaLinks />
						</Grid>
					</Grid>
				</Box>
			</Section>
		</div>
	);
};

export default HeaderNavSubMenu;
